import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";
import BackButton from "../components/BackButton";
import Distraction from "../components/distraction/Distraction";
import PhoneDistraction from "../components/distraction/distractions/PhoneDistraction";
import DistractionManager from "../components/distraction/DistractionManager";
import BallDistraction from "../components/distraction/distractions/BallDistraction";
import WindowDistraction from "../components/distraction/distractions/WindowDistraction";
import TvDistraction from "../components/distraction/distractions/TvDistraction";
import TryAgainButton from "../components/TryAgainButton";
import ContinueButton from "../components/ContinueButton";
import { Countdown } from "../components/distraction/Countdown";

const minigameConfig = {
    loseScore: 100,

    distractions: {
        phone: {x: 730, y: 430, depth: 5},
        ball: {x: 190, y: 395, depth: 5},
        window: {x: 142, y: 315, depth: 2},
        tv: {x: 748, y: 164, depth: 5},
    } 

}

export class DistractionScene extends MinigameScene {

    private isRestart = false;
    private startSurvivalTime = 0;

    private distractions !: Distraction[];
    private distractionManager !: DistractionManager;

    private survivalTimeText !: Phaser.GameObjects.Text;
    private highscoreImage !: Phaser.GameObjects.Image;

    private playerLost = false;

    private countdown !: Countdown;

    constructor(){
        super ({
            sceneName: CONST.SCENES.DISTRACTION,
            duration: 999999999,
            showCountdown: 0,
            showHomeButton: false,
            timeToStart: 1000,
            startScreenColor: 0xFFD400,
            startText: "KEEP YOUR\nFOCUS!",
            startTextYOrigin: 0.45,
            startTextColor: 0x323232,
            endScreen: CONST.DISTRACTION.END,
            showSkipButton: false,
            nextScene: CONST.SCENES.BIRTH,
            endButtons: {
                normalNoSkip: {x: -426.5, y: 386, scale: 1.30},
                normalWithSkip: {x: 283, y: 386, scale: 1.30},
                skip: {x: 570, y: 386, scale: 1.30}
            },
            isArcadeMinigame: true,
          })
    }

    _init(){
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.distractions = [];
        this.distractionManager = null;

        this.playerLost = false;

        this.startSurvivalTime = 0;

        this.isRestart = this.checkForRestart();
    }

    private checkForRestart(): boolean{
        let key = this.sceneName + "restart";
        let restartInfo = this.storagePlugin.getItem(key, "");
        if (restartInfo){
            let parsed = JSON.parse(restartInfo);
            this.startSurvivalTime = parsed.time;

            this.storagePlugin.removeItem(key);
            return true;
        }

        return false;
    }

    _preload(){
    }

    _create(){
        this.createBackground();
        this.createCharacter();

        this.createDistractions();

        this.createDistractionDisplay();
    }

    createBackground() {
        this.add.image(0,0, CONST.DISTRACTION.BACKGROUND).setOrigin(0,0).setDepth(3);

        this.add.image(140.8, 176.3, CONST.DISTRACTION.WINDOW_FRONT).setDepth(4);
        this.add.image(137.8, 189, CONST.DISTRACTION.WINDOW_BACK).setDepth(1);
        this.add.image(427, 76, CONST.DISTRACTION.CLOUD).setDepth(45);
    }

    createCharacter(){
        new Character(this);
    }

    createDistractions(){
        //hardcode spawning distractions
        let phone = new PhoneDistraction(this, minigameConfig.distractions.phone);
        let ball = new BallDistraction(this, minigameConfig.distractions.ball);
        let window = new WindowDistraction(this, minigameConfig.distractions.window);
        let tv = new TvDistraction(this, minigameConfig.distractions.tv);

        this.distractions.push(...[phone, ball, window, tv]);

        this.distractionManager = new DistractionManager(this.distractions, this.startSurvivalTime, this);
    }

    //Shows the "loading bar" of how much the player is distracted!
    createDistractionDisplay(){
        this.countdown  =  new Countdown({
            scene: this,
            position: {x: 407, y: 41},
            maxValue: 100,
            depth: 50,
        });
    }

    _update(time: number, delta: number){
        this.distractionManager._update(time, delta);
        this.checkScore();
    }

    checkScore(){
        let score = this.distractionManager.getScore();
        this.updateDistractionDisplay(score);

        if (score >= minigameConfig.loseScore){
            this.triggerLose();
        }
    }

    updateDistractionDisplay(score: number){
        this.countdown.displayScore(score);
    }


    onGameStarted(){
        this.distractionManager.startSpawning();
    }

    _timeout(){
       // this.loseGame();
    }

    _afterLoss(){
    }

    _afterWin(){
    }

    private triggerLose(){
        if (this.playerLost) return;
        this.playerLost = true;

        this.sound.play(CONST.AUDIO.LOSE, {volume: 4});

        this.distractionManager.onGameLost();
        this.saveAndDisplayScore();

        setTimeout(() => {
            this.distractions.forEach(d => d.forceDisable());
        }, 2000);

        this.loseGame(2000);
    }

    private triggerWin(){
        //trigger win after 1 second and load next scene
        this.winGame(1000);
    }

    private saveAndDisplayScore(){
        var score = this.calculateScore();
        var oldHighscore = this.getHighscore();
        var isNewHighscore = score > oldHighscore;

        this.displayScore(score, isNewHighscore, oldHighscore);

        if (isNewHighscore){
            this.setHighscore(score);
        }

        this.sendFinalScoreAnalyticsEvent(score);
    }

    private calculateScore(){
        let score = this.distractionManager.getSurvivalTimeInSeconds();
        return score;
    }

    private displayScore(score: number, isHighscore: boolean, oldHighscore: number){
        this.survivalTimeText.text = score.toString();
        let scoreLength =  this.survivalTimeText.text.length;

        if(scoreLength == 1){
            this.survivalTimeText.x = 504;
            this.survivalTimeText.y = 152;
            this.highscoreImage.x = 501;
            this.highscoreImage.y = 152;
        }
        if(scoreLength == 2){
            this.survivalTimeText.x = 491;
            this.survivalTimeText.y = 150;
            this.highscoreImage.x = 489;
            this.highscoreImage.y = 151;
        } 
        if(scoreLength == 3){
            this.survivalTimeText.x = 476.3;
            this.survivalTimeText.y = 151.6;
            this.highscoreImage.x = 476.8;
            this.highscoreImage.y = 152.6;
        }
        if(scoreLength >= 4){
            this.survivalTimeText.x = 462.5;
            this.survivalTimeText.y = 150.8;
            this.highscoreImage.x = 460.5;
            this.highscoreImage.y = 152.6;
        }

        this.highscoreImage.setAlpha(isHighscore ? 1 : 0);
    }

    protected getCustomLoseUIElements() : object[] {
        this.highscoreImage = this.add.image(484, 152, CONST.DISTRACTION.NEW_BEST).setDepth(3);

        this.survivalTimeText = this.add.text(484, 152, "123",
        {fontFamily: 'bloggerSans', fontSize: 35, color: "#C92A88", align: 'center'})
        .setDepth(2);

        if (this.isRestart || this.registry.get(CONST.REGISTRY.ADBLOCKENABLED)){
            //Without continue button
            var backButton2 = new BackButton(CONST.SCENES.MENU, 686, 231, this, CONST.DISTRACTION.BACK).setScale(1.1);
            var tryAgainButton2 = new TryAgainButton(710.5, 302, this, CONST.DISTRACTION.TRY_AGAIN_2).setScale(1.1).setDepth(2);
            return [backButton2, tryAgainButton2, this.survivalTimeText, this.highscoreImage];

        } else {
            //With continue button
            var backButton = new BackButton(CONST.SCENES.MENU, 733, 380, this, CONST.DISTRACTION.BACK_2).setScale(1.1);
            var continueButton = new ContinueButton(713, 303, this, CONST.DISTRACTION.CONTINUE, () => {return this.getContinueData()}).setScale(1.1);
            var tryAgainButton = new TryAgainButton(680, 233, this, CONST.DISTRACTION.TRY_AGAIN).setDepth(2);
            return [backButton, continueButton, tryAgainButton, this.survivalTimeText, this.highscoreImage];
        }
    }

    getContinueData(){
        return {time: this.distractionManager.getSurvivalTime()};
    }
}

class Character {
    private scene : Phaser.Scene;
    private container : Phaser.GameObjects.Container;

    private characterArm: Phaser.GameObjects.Container;
    private characterHand: Phaser.GameObjects.Container;

    private handImage: Phaser.GameObjects.Image;

    private writeTween !: Phaser.Tweens.Tween;

    constructor(scene: Phaser.Scene){
        this.scene = scene;

        this.container = scene.add.container(420, 237).setDepth(4);

        this.characterArm = scene.add.container(-40,65);
        let armImage = scene.add.image(0, 0, CONST.DISTRACTION.ARM).setOrigin(0.80, 0.10);
        this.characterArm.add([armImage]);

        this.characterHand = scene.add.container(-40, 65);
        this.handImage = scene.add.image(-20, 80, CONST.DISTRACTION.HAND).setOrigin(0.3, 0.6);
        this.characterHand.add([this.handImage]);

        let characterBase = scene.add.image(0, 0, CONST.DISTRACTION.CHARACTER);

        this.container.add([this.characterArm, characterBase, this.characterHand]);

        this.animate(scene);
    }

    animate(scene: Phaser.Scene){
        this.characterArm.setAngle(-20);
        this.characterHand.setAngle(-20);

        scene.tweens.timeline({
            targets: [this.characterArm, this.characterHand],
            loop: -1,
            tweens: [
                { //Write line
                    angle: 5,
                    duration:5000,
                    ease: "Quad.easeInOut",
                    hold: 300,
                    onStart: function () {
                        this.setWriteAnimation(true);
                    },
                    onStartScope: this,
                },
                {
                    angle: -20,
                    duration: 500,
                    ease: "Quad.easeInOut",
                    onStart: function () {
                        this.setWriteAnimation(false);
                    },
                    onStartScope: this,
                }
            ]
        });
    }

    setWriteAnimation(playing: boolean){
        if (this.writeTween){
            this.writeTween.stop();
        }

        if (playing){
            this.writeTween = this.scene.tweens.add({
                targets: this.handImage,
                angle: "+=2",
                duration: 5000,
                hold: 750,
                yoyo: true,
                repeat: -1,
                ease: (t: number) => {return this.wiggle(t, 7, 7)},
            });
        }
    }

    private wiggle(aProgress: number, aPeriod1: number, aPeriod2: number): number {
        var current1: number = aProgress * Math.PI * 2 * aPeriod1;
        var current2: number = aProgress * (Math.PI * 2 * aPeriod2 + Math.PI / 2);

        return Math.sin(current1) * Math.cos(current2);
    }
}
